import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import {
  SelectorsRevisionsList,
  SelectorsRevisionsListV
} from "@/types/revisions";
import { toUnion } from "fp-ts/Either";
import { mapLeft } from "fp-ts/lib/Either";

export async function fetchRemoteSelectorsRevisions(): Promise<SelectorsRevisionsList | null> {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_retrieve_selectors_revisions",
      decoder: SelectorsRevisionsListV
    }),
    // makeWordPressAjaxRequest does all the error logging already, there's no point to call logErrorsToUiStore()
    mapLeft(() => null),
    toUnion
  );
}
